import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const send_email = (
  emailTemplateId,
  toEmailUser,
  locating,
  replace,
  subjectlocating,
  subjectreplace,
  selectedFileId
) => {
  // include selectedFileId if provided — backend may ignore unknown fields
  const payload = {
    emailTemplateId,
    toEmailUser,
    locating,
    replace,
    subjectlocating,
    subjectreplace,
  };
  if (
    selectedFileId !== undefined &&
    selectedFileId !== null &&
    selectedFileId !== ""
  ) {
    payload.selectedFileId = selectedFileId;
  }
  return api.post(`${ApiEndpointConstants.SENDEMAIL}`, payload);
};
